import { useSelector } from 'react-redux';

import { RootState } from '../types';

export const useUserToken = () => {
  const token = useSelector((s: RootState) => s.auth.account.token);

  return { token };
};
